
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurancesupersaver/[category]",
      function () {
        return require("private-next-pages/insurancesupersaver/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurancesupersaver/[category]"])
      });
    }
  